/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_CoachingInputs */

const en_mk_foot_coaching = /** @type {(inputs: Mk_Foot_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const id_mk_foot_coaching = /** @type {(inputs: Mk_Foot_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

/**
* | output |
* | --- |
* | "Coaching" |
*
* @param {Mk_Foot_CoachingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_coaching = /** @type {((inputs?: Mk_Foot_CoachingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CoachingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_coaching(inputs)
	return en_mk_foot_coaching(inputs)
});